import { Breadcrumbs, Link, Typography } from "@mui/material";
import FileTable from "./FileTable";
import SearchResults from "./SearchResults";
import UploadControl from "./UploadControl";

/** Root-to-selected-folder breadcrumb trail; clicking "Library" clears the selection. */
const LibraryBreadcrumb = ({ breadcrumb, onSelectFolder }) => (
  <Breadcrumbs sx={{ px: 1, py: 0.5 }}>
    <Link component="button" underline="hover" onClick={() => onSelectFolder(null)}>
      Library
    </Link>
    {breadcrumb.map((folder) => (
      <Link
        key={folder.id}
        component="button"
        underline="hover"
        onClick={() => onSelectFolder(folder.id)}
      >
        {folder.name}
      </Link>
    ))}
  </Breadcrumbs>
);

/**
 * The library's right-hand pane: search results while a search is active, otherwise the
 * breadcrumb trail, upload control, and file table for the currently selected folder.
 */
const LibraryContent = ({
  activeSearch,
  searchResult,
  onOpenSearchFolder,
  onOpenSearchFile,
  breadcrumb,
  selectedFolderId,
  onSelectFolder,
  canCreate,
  uploadName,
  onUploadNameChange,
  onUpload,
  uploading,
  files,
  fileHandlers,
}) => {
  if (activeSearch) {
    return (
      <SearchResults
        result={searchResult}
        onOpenFolder={onOpenSearchFolder}
        onOpenFile={onOpenSearchFile}
      />
    );
  }

  return (
    <>
      <LibraryBreadcrumb breadcrumb={breadcrumb} onSelectFolder={onSelectFolder} />
      {!selectedFolderId ? (
        <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
          Pick a folder to see its documents.
        </Typography>
      ) : (
        <>
          {canCreate && (
            <UploadControl
              uploadName={uploadName}
              onNameChange={onUploadNameChange}
              onUpload={onUpload}
              uploading={uploading}
            />
          )}
          <FileTable files={files} {...fileHandlers} />
        </>
      )}
    </>
  );
};

export default LibraryContent;
